import React from "react";

function Emoji({ e }) {
  return (
    <span className="emoji" role="img">
      {e}
    </span>
  );
}

export default Emoji;
